import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { INCLUDE_CLOSING_POINTS_ACCOUNTS } from '@rd/core/tokens/rd-lib.token';
import { PointsAccount } from '@rd/types';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import {
  LoadPointsAccounts,
  NoopPointsAccountSelectionEnded,
} from '../../store/actions/points-account.actions';
import { getPointsAccountsFeatureState } from '../../store/reducers';

@Injectable()
export class PointsAccountFacade {
  constructor(
    @Inject(INCLUDE_CLOSING_POINTS_ACCOUNTS)
    private includeClosingPointsAccounts: boolean,
    private store: Store,
  ) {}

  totalPointsBalance$: Observable<number> = this.store
    .select(getPointsAccountsFeatureState)
    .pipe(
      map((state) =>
        state.pointsAccounts.reduce(
          (total: number, pointsAccount: PointsAccount) => {
            return total + pointsAccount.pointsBalance;
          },
          0,
        ),
      ),
      distinctUntilChanged(),
    );

  loadPointsAccountError$: Observable<boolean> = this.store
    .select(getPointsAccountsFeatureState)
    .pipe(
      map((state) => state.error),
      distinctUntilChanged(),
    );

  pointsAccounts$: Observable<PointsAccount[]> = this.store
    .select(getPointsAccountsFeatureState)
    .pipe(
      map((state) => state.pointsAccounts),
      distinctUntilChanged(),
    );

  loadPointsAccountsLoading$: Observable<boolean> = this.store
    .select(getPointsAccountsFeatureState)
    .pipe(
      map((state) => state.loading),
      distinctUntilChanged(),
    );

  loadPointsAccounts(): void {
    this.store.dispatch(
      new LoadPointsAccounts({
        includeClosingPointsAccounts: this.includeClosingPointsAccounts,
      }),
    );
  }

  triggerEffectsAfterPointsAccountSelection(): void {
    this.store.dispatch(NoopPointsAccountSelectionEnded());
  }
}
